export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resetovat"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vybrat vše"])}
}